import { Dispatch, SetStateAction, useState } from 'react'
import { Helmet } from 'react-helmet-async'
import BottomTree, { IBottomTreeColumn } from './BottomTree'
import { FlexDiv } from './flexdiv'
import InputBox from './InputBox'
import { useSyncedState } from './hooks/useSyncedState'
import InputYearDropdown from './InputYearDropdown'
import VSOTable from './VSOTable'
//import woohooo from './assets/home/wwwwoohooo.png'
import woohooo from './assets/woohooo.gif'
import vsosudokulogo from './assets/vsosudokulogo3.png'
import { useWindowDimensions } from './hooks/useWindowDimensions'

export const getValueForId = (columns: IBottomTreeColumn[], id: string): string | undefined => {
  for (const column of columns) {
    if (column.top?.id === id) {
      return column.top.value
    }
    if (column.bottom?.id === id) {
      return column.bottom.value
    }
  }
  return undefined
}

export const safeConvertStringToNumber = (s: string | undefined) => {
  if (s === undefined) return undefined
  s = s.trim().replaceAll('.', '')
  const v = parseInt(s, 10)
  if (s === `${v}`) {
    return v
  }
  return undefined
}

export const skattepligtigtOverskudId = 'skattepligtigtOverskud'
export const kapitalAfkastId = 'kapitalAfkast'
export const resterendeOverskudId = 'resterendeOverskud'
export const haevetPersonligIndkomstId = 'haevetPersonligIndkomstId'
export const indkomstTilVirksomhedsbeskatningId = 'indkomstTilVirksomhedsbeskatning'
export const kontoTilOpsparetOverskudId = 'kontoTilOpsparetOverskud'
export const kontoTilOpsparetOverskudText = 'Konto for opsparet overskud (tilgang)'
export const virksomhedsskatId = 'virksomhedsskat'
export const virksomhedsskatText = 'Virksomhedsskat'

const calcKapitalAfkast = (columns: IBottomTreeColumn[], fromLeft: boolean, primaryId: String, extraData: IExtraData | undefined): string | undefined => {
  const kapitalafkastgrundlagPrimoUdgoer = extraData?.kapitalafkastgrundlagPrimoUdgoer ?? 0
  return `${Math.round(Math.max(kapitalafkastgrundlagPrimoUdgoer * 0.02, 0))}`

  // const skattepligtigtOverskud = safeConvertStringToNumber(getValueForId(columns, skattepligtigtOverskudId))
  // const resterendeOverskud = safeConvertStringToNumber(getValueForId(columns, resterendeOverskudId))

  // if (skattepligtigtOverskud !== undefined && resterendeOverskud !== undefined) {
  //   return `${Math.round(Math.max(skattepligtigtOverskud - resterendeOverskud, 0))}`
  // }

  // return undefined
}

const calcResterendeOverskud = (columns: IBottomTreeColumn[], fromLeft: boolean, primaryId: String): string | undefined => {
  const skattepligtigtOverskud = safeConvertStringToNumber(getValueForId(columns, skattepligtigtOverskudId))
  const kapitalAfkast = safeConvertStringToNumber(getValueForId(columns, kapitalAfkastId))
  if (skattepligtigtOverskud !== undefined && kapitalAfkast !== undefined) {
    return `${Math.round(skattepligtigtOverskud >= 0 ? skattepligtigtOverskud - Math.max(kapitalAfkast, 0) : skattepligtigtOverskud)}`
  }

  if (!fromLeft) {
    //console.log('calcResterendeOverskud fra højre')
    const haevetPersonligIndkomst = safeConvertStringToNumber(getValueForId(columns, haevetPersonligIndkomstId))
    const indkomstTilVirksomhedsbeskatning = safeConvertStringToNumber(getValueForId(columns, indkomstTilVirksomhedsbeskatningId))

    if (haevetPersonligIndkomst !== undefined && indkomstTilVirksomhedsbeskatning !== undefined) {
      return `${Math.round(haevetPersonligIndkomst + indkomstTilVirksomhedsbeskatning)}`
    }

    if ((haevetPersonligIndkomst === undefined) !== (indkomstTilVirksomhedsbeskatning === undefined)) {
      return undefined
    }
  }

  return ''
}

const calchaevetPersonligIndkomst = (
  columns: IBottomTreeColumn[],
  fromLeft: boolean,
  primaryId: string,
  extraData: IExtraData | undefined,
): string | undefined => {
  const resterendeOverskud = safeConvertStringToNumber(getValueForId(columns, resterendeOverskudId))
  const indkomstTilVirksomhedsbeskatning = safeConvertStringToNumber(getValueForId(columns, indkomstTilVirksomhedsbeskatningId))
  if (resterendeOverskud !== undefined && indkomstTilVirksomhedsbeskatning !== undefined) {
    return `${Math.round(resterendeOverskud - indkomstTilVirksomhedsbeskatning)}`
  }

  return undefined
}

const calcIndkomstTilVirksomhedsbeskatning = (
  columns: IBottomTreeColumn[],
  fromLeft: boolean,
  primaryId: string,
  extraData: IExtraData | undefined,
): string | undefined => {
  if (fromLeft) {
    //console.log('calcIndkomstTilVirksomhedsbeskatning fra venstre')
    const resterendeOverskud = safeConvertStringToNumber(getValueForId(columns, resterendeOverskudId))
    const haevetPersonligIndkomst = safeConvertStringToNumber(getValueForId(columns, haevetPersonligIndkomstId))

    if (resterendeOverskud !== undefined && haevetPersonligIndkomst !== undefined) {
      return `${Math.round(resterendeOverskud - haevetPersonligIndkomst)}`
    }
    return undefined
  } else {
    //console.log('calcIndkomstTilVirksomhedsbeskatning fra højre')

    const virksomhedsSkatFraction = getVirksomhedsSkatFraction(extraData?.beregningsAar)

    if (primaryId !== virksomhedsskatId) {
      const kontoTilOpsparetOverskud = safeConvertStringToNumber(getValueForId(columns, kontoTilOpsparetOverskudId))
      if (kontoTilOpsparetOverskud !== undefined) {
        return `${Math.round(kontoTilOpsparetOverskud / (1 - virksomhedsSkatFraction))}`
      }
    }

    const virksomhedsskat = safeConvertStringToNumber(getValueForId(columns, virksomhedsskatId))
    if (virksomhedsskat !== undefined) {
      return `${Math.round(virksomhedsskat / virksomhedsSkatFraction)}`
    }
  }

  return ''
}

const calcKontoTilOpsparetOverskud = (columns: IBottomTreeColumn[], fromLeft: boolean, primaryId: string, extraData: IExtraData | undefined): string => {
  const virksomhedsSkatFraction = getVirksomhedsSkatFraction(extraData?.beregningsAar)
  //console.log(`calcKontoTilOpsparetOverskud kaldes med ${extraData?.beregningsAar}`)
  const indkomstTilVirksomhedsbeskatning = safeConvertStringToNumber(getValueForId(columns, indkomstTilVirksomhedsbeskatningId))
  if (indkomstTilVirksomhedsbeskatning === undefined) return ''
  return `${Math.round(indkomstTilVirksomhedsbeskatning * (1 - virksomhedsSkatFraction))}`
}

const calcVirksomhedsskat = (columns: IBottomTreeColumn[], fromLeft: boolean, primaryId: string, extraData: IExtraData | undefined): string => {
  const virksomhedsSkatFraction = getVirksomhedsSkatFraction(extraData?.beregningsAar)
  const indkomstTilVirksomhedsbeskatning = safeConvertStringToNumber(getValueForId(columns, indkomstTilVirksomhedsbeskatningId))
  if (indkomstTilVirksomhedsbeskatning === undefined) return ''
  return `${Math.round(indkomstTilVirksomhedsbeskatning * virksomhedsSkatFraction)}`
}

const buildInitialColumns = () =>
  [
    {
      // top: {
      //   text: 'Base top 1',
      // },
      bottom: {
        id: skattepligtigtOverskudId,
        text: 'Skattepligtigt overskud\n(efter eventuel medarbejende ægtefælle)',
      },
    },
    {
      top: {
        id: kapitalAfkastId,
        text: 'Kapitalafkast',
        calc: calcKapitalAfkast,
      },
      bottom: {
        id: resterendeOverskudId,
        text: 'Resterende overskud\n+ eventtuelt resterende kapitalafkast',
        calc: calcResterendeOverskud,
      },
    },
    {
      top: {
        id: haevetPersonligIndkomstId,
        text: 'Hævet personlig indkomst',
        calc: calchaevetPersonligIndkomst,
      },
      bottom: {
        id: indkomstTilVirksomhedsbeskatningId,
        text: 'Indkomst til virksomheds- beskatning',
        calc: calcIndkomstTilVirksomhedsbeskatning,
      },
    },
    {
      top: {
        id: kontoTilOpsparetOverskudId,
        text: kontoTilOpsparetOverskudText,
        calc: calcKontoTilOpsparetOverskud,
      },
      bottom: {
        id: virksomhedsskatId,
        text: virksomhedsskatText,
        calc: calcVirksomhedsskat,
      },
    },
  ] as IBottomTreeColumn[]

const setTextForId = (id: string, text: string, setColumns: Dispatch<SetStateAction<IBottomTreeColumn[]>>) => {
  setColumns(columns => {
    return columns.map(column => {
      return {
        top:
          column.top?.id === id
            ? {
                ...column.top,
                text,
              }
            : column.top,
        bottom:
          column.bottom?.id === id
            ? {
                ...column.bottom,
                text,
              }
            : column.bottom,
      } as IBottomTreeColumn
    })
  })
  return
}

interface IExtraData {
  beregningsAar: number
  kapitalafkastgrundlagPrimoUdgoer: number | undefined
}

const setValueForId = (
  id: string,
  value: string,
  setColumns: (value: IBottomTreeColumn[] | ((prev: IBottomTreeColumn[]) => IBottomTreeColumn[])) => void /*Dispatch<SetStateAction<IBottomTreeColumn[]>>*/,
  extraData?: IExtraData,
  recalcAll?: boolean,
) => {
  recalcAll ??= true

  /*
  IVB = KFO + VS

  RO = IVB + PI

  SO = KA + RO

  Hvis jeg piller ved IVB vil jeg gerne have at KFO, VS beregnes og ligeledes RO.. som igen så spawner en beregning af SO.

  Problemet er at hvis jeg har en for-løkke der løber colums igennem efter IVB er sat, som først støder på beregning af SO,
  da vil SO kunne beregnes udfra værdierne i KA og RO, men de er ikke opdateret endnu udfra den nye værdi i IVB.

  Jeg skal på en eller anden måde styre at opdateringen forgrenes ud fra og med IVB:
  Dvs en liste ala følgende burde opbygges ala.. hvor først går vi helt til højre og derefter helt til venstre
  KFO
  VS  
  RO
  PI (Vi går til højre når vi kan)
  SO
  KA  
  */

  /*
    Vi bølger helt ud til venstre... og så til højre
  */

  interface IChangeIdAndPlacement {
    id: string
    left: boolean
  }

  const getChangeIdAndPlacements = (columns: IBottomTreeColumn[], idToChange: string): IChangeIdAndPlacement[] => {
    const changeIdAndPlacements: IChangeIdAndPlacement[] = []
    const changeIdsLookup = new Set<string>()

    // Add all bottoms from current and to front
    for (let i = columns.length - 1; i >= 0; i--) {
      const column = columns[i]

      if (column.top?.id === idToChange || column.bottom.id === idToChange) {
        for (let j = i - 1; j >= 0; j--) {
          const columnJ = columns[j]
          changeIdAndPlacements.push({
            id: columnJ.bottom.id,
            left: true,
          })
          changeIdsLookup.add(columnJ.bottom.id)
        }
      }
    }

    for (let i = 0; i < columns.length; i++) {
      const column = columns[i]

      if (column.top?.id && column.top?.id !== idToChange && !changeIdsLookup.has(column.top?.id)) {
        changeIdAndPlacements.push({
          id: column.top.id,
          left: false,
        })
        changeIdsLookup.add(column.top.id)
      }

      if (column.bottom?.id && column.bottom?.id !== idToChange && !changeIdsLookup.has(column.bottom?.id)) {
        changeIdAndPlacements.push({
          id: column.bottom.id,
          left: false,
        })
        changeIdsLookup.add(column.bottom.id)
      }
    }

    return changeIdAndPlacements
  }

  const updateIdWithValue = (columns: IBottomTreeColumn[], idToChange: string, value: string) => {
    return columns.map(column => {
      return {
        top:
          column.top?.id === idToChange
            ? {
                ...column.top,
                value,
              }
            : column.top,
        bottom:
          column.bottom?.id === idToChange
            ? {
                ...column.bottom,
                value,
              }
            : column.bottom,
      } as IBottomTreeColumn
    })
  }

  // const roundOrUndefined = (value: number | undefined) => {
  //   if (value === undefined) return undefined
  //   return Math.round(value)
  // }

  const updateIdWithCalc = (columns: IBottomTreeColumn[], changeIdAndPlacement: IChangeIdAndPlacement, primaryId: string) => {
    return columns.map(column => {
      return {
        top:
          column.top?.id === changeIdAndPlacement.id && column.top?.calc
            ? {
                ...column.top,
                value: column.top.calc(columns, !changeIdAndPlacement.left, primaryId, extraData) ?? column.top.value,
              }
            : column.top,
        bottom:
          column.bottom?.id === changeIdAndPlacement.id && column.bottom?.calc
            ? {
                ...column.bottom,
                value: column.bottom.calc(columns, !changeIdAndPlacement.left, primaryId, extraData) ?? column.bottom.value,
              }
            : column.bottom,
      } as IBottomTreeColumn
    })
  }

  setColumns(prev => {
    let next = updateIdWithValue(prev, id, value)

    if (recalcAll) {
      const changeIdAndPlacements = getChangeIdAndPlacements(next, id)
      // console.log('changeIdAndPlacements=======')
      // console.log(changeIdAndPlacements)
      for (const changeIdAndPlacement of changeIdAndPlacements) {
        next = updateIdWithCalc(next, changeIdAndPlacement, id)
      }
    }
    return next

    // let next = prev
    // let prevNodeDataListCounter = 0
    // let idToChange: string | undefined = id
    // let debug = 0
    // do {
    //   console.log(`debug = ${debug}`)
    //   prevNodeDataListCounter = Array.from(changedIds.values()).length
    //   next = updateIdWithValue(next, idToChange, value)
    //   console.log('node rettet')
    //   idToChange = undefined // only want to change the primary value with the id at the first run
    //   debug++
    //   console.log(`prevNodeDataListCounter = ${prevNodeDataListCounter} Array.from(changedNodeIds.values()).length=${Array.from(changedIds.values()).length}`)
    // } while (prevNodeDataListCounter < Array.from(changedIds.values()).length)

    // return next
  })
}

const getVirksomhedsSkatFraction = (beregningsAar: number | undefined) => {
  if (beregningsAar === undefined) return 0.22
  if (beregningsAar <= 1990) return 0.5
  if (beregningsAar <= 1991) return 0.38
  if (beregningsAar <= 1998) return 0.34
  if (beregningsAar <= 2000) return 0.32
  if (beregningsAar <= 2004) return 0.3
  if (beregningsAar <= 2006) return 0.28
  if (beregningsAar <= 2013) return 0.25
  if (beregningsAar <= 2014) return 0.245
  if (beregningsAar <= 2015) return 0.235
  return 0.22
}

const updateTexts = (beregningsAar: number, setColumns: Dispatch<SetStateAction<IBottomTreeColumn[]>>) => {
  setTextForId(
    kontoTilOpsparetOverskudId,
    `${kontoTilOpsparetOverskudText}\n${Math.round((1 - getVirksomhedsSkatFraction(beregningsAar)) * 1000) / 10}%`,
    setColumns,
  )
  setTextForId(virksomhedsskatId, `${virksomhedsskatText}\n${Math.round(getVirksomhedsSkatFraction(beregningsAar) * 1000) / 10}%`, setColumns)
}

const setInitialColumns = (
  resultatEfterRenterInput: string,
  aaretsHaevningerUdgoerInput: string,
  hensatTilSenereHaevningPrimoInput: string,
  kapitalafkastgrundlagPrimoUdgoerInput: string,
  oenskesHaevetPIInput: string,
  privateUdlaegUdgoerInput: string,
  overfoerselTilMedarbejdendeAegtefaelleInput: string,
  beregningsAar: number,
) => {
  let columns = buildInitialColumns()

  const setLocaleColumns = (value: IBottomTreeColumn[] | ((prev: IBottomTreeColumn[]) => IBottomTreeColumn[])) => {
    const newValue = typeof value === 'function' ? value(columns) : value
    columns = newValue
    return newValue
  }

  try {
    const resultatEfterRenter = safeConvertStringToNumber(resultatEfterRenterInput)
    const aaretsHaevningerUdgoer = safeConvertStringToNumber(aaretsHaevningerUdgoerInput)
    const hensatTilSenereHaevningPrimo = safeConvertStringToNumber(hensatTilSenereHaevningPrimoInput)
    const kapitalafkastgrundlagPrimoUdgoer = safeConvertStringToNumber(kapitalafkastgrundlagPrimoUdgoerInput)
    const oenskesHaevetPI = safeConvertStringToNumber(oenskesHaevetPIInput)
    const privateUdlaegUdgoer = safeConvertStringToNumber(privateUdlaegUdgoerInput)
    const overfoerselTilMedarbejdendeAegtefaelle = safeConvertStringToNumber(overfoerselTilMedarbejdendeAegtefaelleInput)

    const extraData = {
      beregningsAar,
      kapitalafkastgrundlagPrimoUdgoer,
    } as IExtraData

    // console.log(`oenskesHaevetPI = ${oenskesHaevetPI}`)
    if (oenskesHaevetPI !== undefined) {
      const haevetPersonligIndkomst = `${Math.round(oenskesHaevetPI)}`
      setValueForId(haevetPersonligIndkomstId, haevetPersonligIndkomst, setLocaleColumns, extraData)
    }

    if (resultatEfterRenter !== undefined) {
      const skattepligtigtOverskud = `${Math.round(resultatEfterRenter - (overfoerselTilMedarbejdendeAegtefaelle ?? 0))}`
      setValueForId(skattepligtigtOverskudId, skattepligtigtOverskud, setLocaleColumns, extraData)
    }

    if (kapitalafkastgrundlagPrimoUdgoer !== undefined) {
      const kapitalAfkast = `${Math.round(kapitalafkastgrundlagPrimoUdgoer * 0.02)}`
      setValueForId(kapitalAfkastId, kapitalAfkast, setLocaleColumns, extraData)
    }

    const skattepligtigtOverskud = safeConvertStringToNumber(getValueForId(columns, skattepligtigtOverskudId))
    if (oenskesHaevetPI === undefined && skattepligtigtOverskud !== undefined) {
      // udover vi skal beregne konto for opsparet overskud, så skal vi sikre at PI er ukendt, da den da vil blive beregnet
      setValueForId(haevetPersonligIndkomstId, '', setLocaleColumns, extraData, false)

      const privateUdlaeg = privateUdlaegUdgoer ?? 0
      const haevninger = aaretsHaevningerUdgoer ?? 0

      const kontoTilOpsparetOverskud = skattepligtigtOverskud - haevninger + privateUdlaeg
      console.log(`kontoTilOpsparetOverskud = ${kontoTilOpsparetOverskud}`)
      console.log(`skattepligtigtOverskud = ${skattepligtigtOverskud}`)
      console.log(`haevninger = ${haevninger}`)
      console.log(`privateUdlaeg = ${privateUdlaeg}`)
      setValueForId(kontoTilOpsparetOverskudId, `${Math.round(kontoTilOpsparetOverskud)}`, setLocaleColumns, extraData)
    }
  } finally {
    updateTexts(beregningsAar, setLocaleColumns)
  }

  return columns
}

const VSOSudoku = () => {
  const [resultatEfterRenter, setResultatEfterRenter] = useState('')
  const [aaretsHaevningerUdgoer, setAaretsHaevningerUdgoer] = useState('')
  const [hensatTilSenereHaevningPrimo, setHensatTilSenereHaevningPrimo] = useState('')
  const [kapitalafkastgrundlagPrimoUdgoer, setKapitalafkastgrundlagPrimoUdgoer] = useState('')
  const [oenskesHaevetPI, setOenskesHaevetPI] = useState('')
  const [privateUdlaegUdgoer, setPrivateUdlaegUdgoer] = useState('')
  const [overfoerselTilMedarbejdendeAegtefaelle, setOverfoerselTilMedarbejdendeAegtefaelle] = useState('')
  const [beregningsAar, setBeregningsAar] = useState(new Date().getFullYear())

  const [columns, setColumns] = useSyncedState<IBottomTreeColumn[]>(
    prevColumns => {
      return setInitialColumns(
        resultatEfterRenter,
        aaretsHaevningerUdgoer,
        hensatTilSenereHaevningPrimo,
        kapitalafkastgrundlagPrimoUdgoer,
        oenskesHaevetPI,
        privateUdlaegUdgoer,
        overfoerselTilMedarbejdendeAegtefaelle,
        beregningsAar,
      )
    },
    [
      resultatEfterRenter, //0
      aaretsHaevningerUdgoer, //1
      hensatTilSenereHaevningPrimo, //2
      kapitalafkastgrundlagPrimoUdgoer, //3
      oenskesHaevetPI, //4
      privateUdlaegUdgoer, //5
      overfoerselTilMedarbejdendeAegtefaelle, //6
      beregningsAar, //7
    ],
  )

  //  return <div style={{ display: 'inline-block', border: '2px solid blue' }}>wtf</div>

  // return (
  //   <BottomTree
  //     columns={columns}
  //     onValueChanged={(id, value) => {
  //       setValueForId(id, value, setColumns, {
  //         beregningsAar,
  //         kapitalafkastgrundlagPrimoUdgoer: safeConvertStringToNumber(kapitalafkastgrundlagPrimoUdgoer),
  //       })
  //     }}
  //   />
  // )

  const { height } = useWindowDimensions()

  return (
    <>
      <Helmet>
        <title>VSO Sudoku</title>
        <link rel="icon" type="image/png" sizes="32x32" href="/icons/vsosudoku/vsosudoku32.png" />
        <link rel="icon" type="image/png" sizes="96x96" href="/icons/vsosudoku/vsosudoku96.png" />
        <link rel="apple-touch-icon" sizes="180x180" href="/icons/vsosudoku/vsosudoku180.png" />
        <link rel="manifest" href="/icons/vsosudoku/manifest.json" />
      </Helmet>
      <FlexDiv direction="column" align="center" style={{ padding: 0, backgroundColor: '#eee', height }}>
        <FlexDiv
          style={{
            position: 'relative',
            fontSize: 50,
            fontWeight: 'bold',
            marginTop: 30,
            marginBottom: 30,
            justifyContent: 'center',
          }}
        >
          <img src={vsosudokulogo} style={{ width: '80%', alignSelf: 'center' }} />
        </FlexDiv>
        <FlexDiv direction="column">
          <FlexDiv direction="row" style={{ alignItems: 'flex-end' }}>
            <InputBox title="Resultat efter renter" value={resultatEfterRenter} onChange={setResultatEfterRenter} maxWidth={200} />
            <InputBox
              title="Årets hævninger udgør"
              value={aaretsHaevningerUdgoer}
              onChange={setAaretsHaevningerUdgoer}
              maxWidth={200}
              style={{ marginLeft: 15 }}
            />
            <InputBox
              title="Hensat til senere hævning (primo)"
              value={hensatTilSenereHaevningPrimo}
              onChange={setHensatTilSenereHaevningPrimo}
              maxWidth={200}
              style={{ marginLeft: 15 }}
            />
            <InputBox
              title="Kapitalafkastgrundlag (primo) udgør"
              value={kapitalafkastgrundlagPrimoUdgoer}
              onChange={setKapitalafkastgrundlagPrimoUdgoer}
              maxWidth={200}
              style={{ marginLeft: 15 }}
            />
          </FlexDiv>
          <FlexDiv direction="row" style={{ marginTop: 15, alignItems: 'flex-end' }}>
            <InputBox title="Ønskes hævet (PI)" value={oenskesHaevetPI} onChange={setOenskesHaevetPI} maxWidth={200} />
            <InputBox title="Private udlæg udgør" value={privateUdlaegUdgoer} onChange={setPrivateUdlaegUdgoer} maxWidth={200} style={{ marginLeft: 15 }} />
            <InputBox
              title="Overførsel til medarbejdende ægtefælle"
              value={overfoerselTilMedarbejdendeAegtefaelle}
              onChange={setOverfoerselTilMedarbejdendeAegtefaelle}
              maxWidth={200}
              style={{ marginLeft: 15 }}
            />
            <InputYearDropdown
              title={'Beregningsår'}
              value={beregningsAar}
              onChange={setBeregningsAar}
              fromYear={1987}
              maxWidth={200}
              style={{ marginLeft: 15 }}
            />
          </FlexDiv>
        </FlexDiv>
        <FlexDiv style={{ marginTop: 40 }} />
        <BottomTree
          columns={columns}
          onValueChanged={(id, value) => {
            setValueForId(id, value, setColumns, {
              beregningsAar,
              kapitalafkastgrundlagPrimoUdgoer: safeConvertStringToNumber(kapitalafkastgrundlagPrimoUdgoer),
            })
          }}
        />
        <VSOTable
          columns={columns}
          resultatEfterRenterInput={resultatEfterRenter}
          aaretsHaevningerUdgoerInput={aaretsHaevningerUdgoer}
          hensatTilSenereHaevningPrimoInput={hensatTilSenereHaevningPrimo}
          kapitalafkastgrundlagPrimoUdgoerInput={kapitalafkastgrundlagPrimoUdgoer}
          oenskesHaevetPIInput={oenskesHaevetPI}
          privateUdlaegUdgoerInput={privateUdlaegUdgoer}
          overfoerselTilMedarbejdendeAegtefaelleInput={overfoerselTilMedarbejdendeAegtefaelle}
        />
        <div style={{ marginTop: 30 }}>
          <img className="App-logo2" src={woohooo} />
        </div>
      </FlexDiv>
    </>
  )
}

export default VSOSudoku
